import * as React from 'react';
import UpdateInfoDialog from '../common/UpdateInfoDialog';
import Icon, { SupportedIcons } from '../common/Icon';
import { AddGiftCardCodes } from '../_service/location';
import { Button } from '@material-ui/core';


interface Props {
    locationId: number;
};


const GiftCards: React.FC<Props> = (prop: Props) => {
    const [isOpen, setIsOpen] = React.useState<boolean>(false);

    const _addGiftCodes = async (formData: any) => {
        if (!formData.textField) return;
        
        let amount: number = Number(formData.input);
        let codes: string[] = formData.textField.split('\n');
        let noEmpties: string[] = codes.filter(String);

        if (isNaN(amount)) alert("Invalid dollar amount.")

        let response = await AddGiftCardCodes(prop.locationId, amount, noEmpties);

        if (response) {
            alert(response.message);
            setIsOpen(false);
            formData = {};
            return;
        }
    }

    return (
        <>
            <Button 
                variant="outlined"
                color="primary"
                onClick={() => setIsOpen(true)}
                startIcon={<Icon iconName={SupportedIcons.AddCircle} color={'primary'}></Icon>}>
                    Add Gift Cards
            </Button>
            <UpdateInfoDialog isOpen={isOpen} 
                title={'Add Gift Cards'}
                handleClose={() => setIsOpen(false)}
                input={{
                    label: 'Dollar Amount',
                    variant: 'standard'
                }}
                content={'Enter the codes corresponding to the Gift Cards at this location and then enter a dollar amount in the input field.'}
                submit={(formData) => _addGiftCodes(formData)}
                textBox={{
                    label: 'codes',
                    placeholder: 'separate codes by line break',
                    rows: 3
                }}
                confirmTxt={'Upload'} /> 
        </>
    )
}

export default GiftCards;